import { isBookingsOnEcom } from '../IsBookingsOnEcom/isBookingsOnEcom';
export const createConfig = ({ experiments, httpClient, getAuthorization, getBaseUrl, }) => {
    return {
        experiments,
        httpClient,
        getAuthorization,
        getBaseUrl,
        isBookingsOnEcomPromise: isBookingsOnEcom({}, { httpClient, experiments, getAuthorization, getBaseUrl }),
    };
};
//# sourceMappingURL=createConfig.js.map